import SEO from "@/components/common/SEO";
import Hero from "@/components/home/Hero";
import {
  StatsBand, ClientsMarquee, EditorialMarquee, WhyChooseUs, ServicesPreview,
  IndustriesPreview, ProcessSection, TechStackSection, CaseStudiesPreview,
  BlogPreview, TrustBadges,
} from "@/components/home/Sections";
import { Testimonials, FAQSection, ContactCTA } from "@/components/shared/blocks";

export default function Home() {
  return (
    <>
      <SEO title="" description="NeuroTriq TechLabs — IT services & technology consulting for enterprises, SMBs and startups. Software, cloud, AI, data, DevOps and security." path="/" />
      <Hero />
      <StatsBand />
      <ClientsMarquee />
      <WhyChooseUs />
      <ServicesPreview />
      <EditorialMarquee />
      <IndustriesPreview />
      <ProcessSection />
      <TechStackSection />
      <Testimonials />
      <CaseStudiesPreview />
      <TrustBadges />
      <BlogPreview />
      <FAQSection limit={8} />
      <ContactCTA />
    </>
  );
}
